// extracted by mini-css-extract-plugin
export default {"container":"LAZcVahrDx","icon":"cxADtNHnQ2","input":"X4H97Hen0L"};